module.exports = __webpack_public_path__ + "img/an-unkindness-of-ghosts.ff332ea5.png";